module.exports = __webpack_public_path__ + "static/img/sm9.209f4ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sm9.png
// module id = gp6B
// module chunks = 1